import { Tooltip, TooltipProps } from '@mantine/core';
import { justMergeSimilar } from '@utils/justMergeSimilar';
import { useMemo } from 'react';
import { useStyles } from './TooltipInternal.styles';

export const TooltipInternal = (props: TooltipProps) => {
  const { className, classNames, ...rest } = props;

  const { classes } = useStyles(undefined, {
    classNames: {
      tooltip: className,
    },
    name: 'Tooltip',
  });
  const mergedClasses = useMemo(() => {
    return justMergeSimilar(classNames || {}, classes);
  }, [classes, classNames?.arrow, classNames?.tooltip]);

  return <Tooltip {...rest} classNames={mergedClasses} />;
};
